import React from 'react';
import ReportTemplateModel, { ReportTemplateModelNames } from './ReportTemplateModel';

const ComponentsList = () => {
    return (
        <ReportTemplateModel
            modelName={ReportTemplateModelNames.Component}
        />
    );
}
export default React.memo(ComponentsList);
